export default __webpack_public_path__ + "static/media/Logo.d140e10d.svg";